import apiClient from '../config/axiosConfig';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error, true);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function searchStreams(term) {
    return function (dispatch) {
        if (term !== '') {
            dispatch({
                type: types.SEARCH_STREAMS_PENDING,
            });
            return apiClient({
                url: `/v2/livestreams/search?email=${encodeURIComponent(term)}`,
                headers: {
                    Accept: 'application/json',
                },
                method: 'GET',
            })
                .then((response) => {
                    dispatch({
                        type: types.SEARCH_STREAMS_SUCCESS,
                        payload: response.data.data,
                    });
                })
                .catch((error) => {
                    errorHandler(dispatch, error.response, types.SEARCH_STREAMS_FAILED);
                });
        }
        return '';
    };
}

export function checkShareFaithEmail(email) {
    return function (dispatch) {
        if (email !== '') {
            dispatch({
                type: types.CHECK_SF_EMAIL_PENDING,
            });
            return apiClient({
                url: `/v2/devotionals/memberId/?email=${encodeURIComponent(email)}`,
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                },
            })
                .then((response) => {
                    dispatch({
                        type: types.CHECK_SF_EMAIL_SUCCESS,
                        payload: response.data.data,
                    });
                })
                .catch((error) => {
                    errorHandler(dispatch, error.response, types.CHECK_SF_EMAIL_FAILED);
                });
        }
        return '';
    };
}
